import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huodong",
  "use": "icon-huodong-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huodong\"><path d=\"M921.6 870.4v102.4H102.4v-102.4h819.2zM307.2 256v512H102.4V256h204.8zM614.4 51.2V768H409.6V51.2h204.8z m307.2 102.4V768h-204.8V153.6h204.8z\" p-id=\"5314\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol